/* eslint-disable react-hooks/exhaustive-deps */
import { auth } from "@/lib/auth";
import { useEffect } from "react";

async function CheckAuthentication() {
  await auth.loginIfNeeded();
}

export function useAuthenticated() {
  useEffect(() => {
    void CheckAuthentication();
  }, [location.pathname]);
}
